module.exports = __webpack_public_path__ + "static/media/verdeShirt.c6f0b46c.jpg";